// extracted by mini-css-extract-plugin
export default {"innerWrapper":"AA-z","tooltipWrapper":"BA-z","icon":"CA-z","tooltip":"DA-z","content":"EA-z"};